import React,{useEffect,useState,useRef} from "react"
import bgImage from "../../../../../assets/blocks/header1/bg.jpeg"
import InlineEditableText from "../../InlineEditableText"
import {Input} from "reactstrap"
import API from "../../../../../utils/API"
import InputColor from 'react-input-color'
import Slider from 'react-input-slider'
import { v4 as uuidv4 } from 'uuid';
import MenuItem from "./MenuItem";
import MenuCategoryItem from "./MenuCategoryItem";
import Switch from "react-switch";
import Restaurant from "./Styles/Restaurant";
import Bar from "./Styles/Bar";
import Coffee from "./Styles/Coffee";

const Menu = (props) => {
    const [showOption, setShowOptions] = useState(false)
    const [data, setData] = useState((props.data)?props.data:props.defaultdata?props.defaultdata:{bgColor:"#ffffff",bgType:'color',titleActive:true,subtitleActive:true,menuElements:[],menuCategoryElements:[],style:'restaurant'})

    const ref = useRef();

    const handleClickOutside = e => {
        if (ref && ref.current && !ref.current.contains(e.target)) {
            setShowOptions(false)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    },[]);

    const setValue = (name,value) => {
        let newData = {
            ...data,
            [name]: value
        }

        setData(newData)
        props.setValue(newData)
    }

    const addMenuElement = () => {
        let currentMenuElements = data.menuElements
        if (!currentMenuElements) {
            currentMenuElements = []
        }
        currentMenuElements.push({id:uuidv4()})
        setValue('menuElements',currentMenuElements)
    }

    const deleteMenuElement = (id) => {
        let currentMenuElements = data.menuElements
        if (currentMenuElements) {
            let newMenuElements = [], n = currentMenuElements.length, i
            for (i=0; i < n; i++) {
                if (currentMenuElements[i].id !== id) {
                    newMenuElements.push(currentMenuElements[i])
                }
            }
            setValue('menuElements',newMenuElements)
        }
    }

    const setMenuElementOptions = (id,name,value) => {
        let currentMenuElements = data.menuElements
        if (currentMenuElements) {
            let newMenuElements = [], n = currentMenuElements.length, i
            for (i=0; i < n; i++) {
                if (currentMenuElements[i].id === id) {
                    currentMenuElements[i][name] = value
                }

                newMenuElements.push(currentMenuElements[i])

            }
            setValue('menuElements',newMenuElements)
        }
    }

    const addMenuCategoryElement = () => {
        let currentMenuCategoryElements = data.menuCategoryElements
        if (!currentMenuCategoryElements) {
            currentMenuCategoryElements = []
        }
        currentMenuCategoryElements.push({id:uuidv4()})
        setValue('menuCategoryElements',currentMenuCategoryElements)
    }

    const deleteMenuCategoryElement = (id) => {
        let currentMenuCategoryElements = data.menuCategoryElements
        if (currentMenuCategoryElements) {
            let newMenuCategoryElements = [], n = currentMenuCategoryElements.length, i
            for (i=0; i < n; i++) {
                if (currentMenuCategoryElements[i].id !== id) {
                    newMenuCategoryElements.push(currentMenuCategoryElements[i])
                }
            }
            setValue('menuCategoryElements',newMenuCategoryElements)
        }
    }

    const setMenuCategoryElementOptions = (id,name,value) => {
        let currentMenuCategoryElements = data.menuCategoryElements
        if (currentMenuCategoryElements) {
            let newMenuCategoryElements = [], n = currentMenuCategoryElements.length, i
            for (i=0; i < n; i++) {
                if (currentMenuCategoryElements[i].id === id) {
                    currentMenuCategoryElements[i][name] = value
                }

                newMenuCategoryElements.push(currentMenuCategoryElements[i])

            }
            setValue('menuCategoryElements',newMenuCategoryElements)
        }
    }

    let image = {
        backgroundRepeat: "no-repeat",
        backgroundPosition : "center",
        backgroundSize: "cover",
        backgroundImage: (!data.bgType || data.bgType === 'image')?`url(${data.bgImage?data.bgImage:bgImage})`:'',
        backgroundColor: (data.bgType && data.bgType === 'color')?(data.bgColor?data.bgColor:'#ffffff'):'',
        position:"relative",
        border:(props.isResult)?"dashed 1px #64afb9":"0",
        paddingTop: (data.paddingTop || data.paddingTop === 0)?data.paddingTop:0,
        paddingBottom: (data.paddingBottom || data.paddingBottom === 0)?data.paddingBottom:0,
    }

    let overlay = {
        background: data.overlayColor?data.overlayColor:"#000000",
        opacity: (data.opacity || data.opacity === 0)?data.opacity:0,
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0
    }

    const handleFileSelect = (event) => {
        let files = event.target.files;
        let reader = new FileReader();
        reader.readAsDataURL(files[0]);

        reader.onload = (e) => {
            API.post('/imageadmin',{image:e.target.result}).then((response) => {
                setValue('bgImage',response.data.data.url)
            });
        }
    }

    return (
        <div style={{position:"relative"}} onClick={(e)=>{if (e.target.tagName.toLowerCase() === 'div'){
            if (props.isResult) {
                setShowOptions(true)
            }
        }}}>
            <div style={image} className="d-flex">
                <div style={overlay}/>
                <div className="w-100 text-white bTitleText">
                    {data.titleActive &&
                        <div className="row justify-content-center">
                            <div className="col-10">
                                <InlineEditableText isResult={props.isResult} name="title"
                                                    setText={setValue}>{data.title ? data.title : '<h1 class="ql-align-center"><span style="color: rgb(0, 0, 255);">View in action</span></h1>'}</InlineEditableText>
                            </div>
                        </div>
                    }
                    {data.subtitleActive &&
                        <div className="row justify-content-center">
                            <div className="col-10">
                                <InlineEditableText isResult={props.isResult} name="subtitle"
                                                    setText={setValue}>{data.subtitle ? data.subtitle : '<p class="ql-align-center"><span style="color: rgb(0, 0, 0);">Sub title</span></p>'}</InlineEditableText>
                            </div>
                        </div>
                    }
                    {data.style === 'restaurant' &&
                        <Restaurant categories={data.menuCategoryElements} items={data.menuElements}/>
                    }
                    {data.style === 'bar' &&
                        <Bar categories={data.menuCategoryElements} items={data.menuElements}/>
                    }
                    {data.style === 'coffee' &&
                        <Coffee categories={data.menuCategoryElements} items={data.menuElements}/>
                    }
                </div>
            </div>
            {showOption &&
                <div ref={ref} className="pb-5" style={{position:"absolute",left:"101%",backgroundColor:"black",top:0,zIndex:"1000",borderRadius:"5px",width:"250px",textAlign:"center",padding:"10px"}}>
                    <div className="row">
                        <div className="col">
                            <span className="text-white">Settings</span>
                        </div>
                    </div>
                    <span className="text-white">Style</span>
                    <div className="row mt-3">
                        <div className="col-6 text-left">
                            <span className="text-white">Restaurant</span>
                        </div>
                        <div className="col-6 text-right">
                            <Input type="radio" style={{width:25,height:25}} name="style" checked={data.style==='restaurant'} onChange={() => setValue('style','restaurant')}/>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-6 text-left">
                            <span className="text-white">Bar menu</span>
                        </div>
                        <div className="col-6 text-right">
                            <Input type="radio" style={{width:25,height:25}} name="style" checked={data.style==='bar'} onChange={() => setValue('style','bar')}/>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-6 text-left">
                            <span className="text-white">Coffee house</span>
                        </div>
                        <div className="col-6 text-right">
                            <Input type="radio" style={{width:25,height:25}} name="style" checked={data.style==='coffee'} onChange={() => setValue('style','coffee')}/>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-6 text-left">
                            <span className="text-white">Title</span>
                        </div>
                        <div className="col-6 text-right">
                            <Switch
                                onColor="#86d3ff"
                                onHandleColor="#2693e6"
                                handleDiameter={30}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={20}
                                width={48}
                                className="react-switch"
                                checked={data.titleActive}
                                onChange={(nextChecked)=>setValue('titleActive',nextChecked)}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-6 text-left">
                            <span className="text-white">Subtitle</span>
                        </div>
                        <div className="col-6 text-right">
                            <Switch onColor="#86d3ff"
                                    onHandleColor="#2693e6"
                                    handleDiameter={30}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={20}
                                    width={48}
                                    className="react-switch"
                                    checked={data.subtitleActive} onChange={(nextChecked)=>setValue('subtitleActive',nextChecked)}/>
                        </div>
                    </div>
                    <span className="text-white">Padding</span>
                    <div className="row mt-3">
                        <div className="col-12 text-left">
                            <span className="text-white">Top</span>
                        </div>
                        <div className="col-12 text-center">
                            <Slider
                                styles={{
                                    active: {
                                        backgroundColor: '#86d3ff'
                                    },
                                    thumb: {
                                        width: 20,
                                        height: 20,
                                        backgroundColor: '#2693e6'
                                    },
                                    disabled: {
                                        opacity: 0.5
                                    }
                                }}
                                xmax={50} xmin={0} xstep={1} axis="x" x={(data.paddingTop || data.paddingTop === 0)?data.paddingTop:0} onChange={({ x }) => setValue('paddingTop',x)} />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12 text-left">
                            <span className="text-white">Bottom</span>
                        </div>
                        <div className="col-12 text-center">
                            <Slider
                                styles={{
                                    active: {
                                        backgroundColor: '#86d3ff'
                                    },
                                    thumb: {
                                        width: 20,
                                        height: 20,
                                        backgroundColor: '#2693e6'
                                    },
                                    disabled: {
                                        opacity: 0.5
                                    }
                                }}
                                xmax={50} xmin={0} xstep={1} axis="x" x={(data.paddingBottom || data.paddingBottom === 0)?data.paddingBottom:0} onChange={({ x }) => setValue('paddingBottom',x)} />
                        </div>
                    </div>
                    <div className="text-white mt-2">Block background</div>
                    <div className="row mt-3">
                        <div className="col-6 text-left">
                            <span className="text-white">Image</span>
                        </div>
                        <div className="col-6 text-right">
                            <Input type="radio" style={{width:25,height:25}} name="bgtype" checked={data.bgType==='image'} onChange={() => setValue('bgType','image')}/>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-6 text-left">
                            <span className="text-white">Color</span>
                        </div>
                        <div className="col-6 text-right">
                            <Input type="radio" style={{width:25,height:25}} name="bgtype" checked={data.bgType==='color'} onChange={() => setValue('bgType','color')} />
                        </div>
                    </div>
                    {data.bgType === 'image' &&
                        <>
                            <div className="row mt-3">
                                <div className="col text-left">
                                    {data.bgImage &&
                                        <img src={data.bgImage} className="img-fluid"/>
                                    }
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-6 text-left">
                                    <input type="file" onChange={handleFileSelect}/>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-6 text-left">
                                    <span className="text-white">Overlay</span>
                                </div>
                                <div className="col-6 text-right">
                                    <InputColor
                                        initialValue={data.overlayColor?data.overlayColor:"#000000"}
                                        onChange={(color)=>setValue('overlayColor',color.hex)}
                                        placement="right"
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 text-left">
                                    <span className="text-white">Opacity</span>
                                </div>
                                <div className="col-12 text-center">
                                    <Slider
                                        styles={{
                                            active: {
                                                backgroundColor: '#86d3ff'
                                            },
                                            thumb: {
                                                width: 20,
                                                height: 20,
                                                backgroundColor: '#2693e6'
                                            },
                                            disabled: {
                                                opacity: 0.5
                                            }
                                        }}
                                        xmax={1} xmin={0} xstep={0.1} axis="x" x={(data.opacity || data.opacity === 0)?data.opacity:0} onChange={({ x }) => setValue('opacity',x)} />
                                </div>
                            </div>
                        </>
                    }
                    {data.bgType === 'color' &&
                        <>
                            <div className="row mt-3">
                                <div className="col text-left">
                                    <InputColor
                                        initialValue={data.bgColor?data.bgColor:"#000000"}
                                        onChange={(color)=>setValue('bgColor',color.hex)}
                                        placement="right"
                                    />
                                </div>
                            </div>

                        </>
                    }
                    <hr style={{backgroundColor:"white",height:"1px",width:"100%"}}/>
                    <div className="row mt-2">
                        <div className="col-6">
                            <button className="btn btn-primary" onClick={()=>addMenuCategoryElement()}>Add category</button>
                        </div>
                        <div className="col-6">
                            <button className="btn btn-success" onClick={()=>addMenuElement()}>Add dish</button>
                        </div>
                    </div>
                    {data.menuCategoryElements.length > 0 &&
                        <>
                            <div className="text-white m-2"><strong>Categories</strong></div>
                            {data.menuCategoryElements.map((menuElement,index)=>{
                                return <MenuCategoryItem key={index} data={menuElement} setValue={setMenuCategoryElementOptions} deleteMenuCategoryElement={deleteMenuCategoryElement}/>
                            })}
                        </>
                    }
                    {data.menuElements.length > 0 &&
                        <>
                            <div className="text-white m-2"><strong>Dishes</strong></div>
                            {data.menuElements.map((menuElement,index)=>{
                                return <MenuItem categories={data.menuCategoryElements} key={index} data={menuElement} setValue={setMenuElementOptions} deleteMenuElement={deleteMenuElement}/>
                            })}
                        </>
                    }
                </div>
            }
        </div>
    )
}

export default Menu
